import { Box, Stack, Typography } from '@mui/material';
import PlotlyChartActions from 'components/Plotly/PlotlyChartActions';
import ThemedPlotlyFigure from 'components/Plotly/ThemedPlotlyFigure';
import { buildMultichannelRangeOverviewFigure } from 'components/StudyDashboard/QCMarkers/normalizationFigures';
import { MarkerNormalizationObservation } from 'components/StudyDashboard/QCMarkers/normalizationInsights';
import { map, max, min } from 'lodash';
import React, { useState } from 'react';

export const NormalizationRangeDistribution = ({
  observations,
  markerLabel,
  boundary,
}: {
  observations: MarkerNormalizationObservation[];
  markerLabel: string;
  boundary: 'minimum' | 'maximum';
}) => {
  const [chartElement, setChartElement] = useState<HTMLElement | null>(null);
  if (!observations.length)
    return (
      <Typography variant="caption" color="text.secondary">
        Not normalized
      </Typography>
    );
  const overview = buildMultichannelRangeOverviewFigure({ observations, getMarkerLabel: () => markerLabel });
  const trace = overview.data[boundary === 'minimum' ? 0 : 1];
  const values = map(observations, boundary === 'minimum' ? 'minValue' : 'maxValue');
  const title = `${markerLabel} ${boundary} across slides`;
  const figure = {
    ...overview,
    data: [trace],
    layout: {
      ...overview.layout,
      title: { text: '' },
      margin: { l: 8, r: 8, t: 8, b: 28 },
      showlegend: false,
      xaxis: { title: { text: '' }, automargin: true },
      yaxis: { visible: false, title: { text: '' } },
    },
  };
  return (
    <Box sx={{ minWidth: 180, maxWidth: 260 }}>
      <Stack direction="row" alignItems="center" justifyContent="space-between">
        <Typography variant="caption" color="text.secondary">
          {min(values)} – {max(values)}
        </Typography>
        <PlotlyChartActions chartEl={chartElement} figure={figure} title={title} />
      </Stack>
      <ThemedPlotlyFigure figure={figure} height={95} onPlotlyInit={setChartElement} />
    </Box>
  );
};
